import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import RequiredLabel from "../../shared/RequiredLabel";

const FormMultilineField = ({
  label,
  rows,
  name,
  value,
  onChange,
  placeholder = "",
  isRequired = false,
  maxLength,
  helperText,
  error = false,
}) => {
  const charCount = value ? value.length : 0;

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography sx={{ fontSize: 14 }}>{label}</Typography>
        <RequiredLabel show={isRequired} />
      </Box>
      <TextField
        fullWidth
        multiline
        rows={rows}
        name={name}
        value={value}
        onChange={onChange}
        error={error}
        placeholder={placeholder}
        inputProps={maxLength ? { maxLength } : {}}
        helperText={helperText || (maxLength ? `${charCount}文字` : undefined)}
        sx={{ "& textarea:focus": { boxShadow: "none" } }}
        FormHelperTextProps={{
          sx: { textAlign: "right", marginRight: "0" },
        }}
      />
    </Box>
  );
};

export default FormMultilineField;
